var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    { attrs: { top: "" } },
    [
      _c(
        "v-btn",
        {
          attrs: {
            slot: "activator",
            fab: "",
            dark: "",
            fixed: "",
            bottom: "",
            right: "",
            small: "",
            color: "primary",
            href: _vm.url,
            target: "_blank"
          },
          slot: "activator"
        },
        [_c("v-icon", { attrs: { dark: "" } }, [_vm._v("help")])],
        1
      ),
      _vm._v(" "),
      _c("span", [_vm._v("Explain this")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d4e4fb5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d4e4fb5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExplainThis.vue
// module id = null
// module chunks = 